const goBack = ()=>{
    if (document.referrer === window.location.href) {
        window.location.href = '/';
    }
    window.location.host === document.referrer.split('/')[2] ? window.history.back() : window.location.href = '/';
};

export { goBack };
//# sourceMappingURL=navigation.js.map
